import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { OktaAuth } from '@okta/okta-auth-js';
import { useDispatch } from 'react-redux';
import OktaConfigLisa from 'configs/OktaConfigLisa';
import { lisaConstants } from 'reduxLib/constants';

export const chatAuth = new OktaAuth(OktaConfigLisa)

export default function LisaCallback() {
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    chatAuth.token.parseFromUrl()
      .then(({ tokens }) => {
        chatAuth.tokenManager.setTokens(tokens);
        // redirect to where user should go after step-up
        history.replace('/redirect');
      })
      .catch(err => {
        dispatch({
          type: lisaConstants.SET_LOGIN_ERROR
        })
        history.replace('/redirect');
      });
  }, [history]);

  return null
}